import { DataGridTypes } from 'devextreme-react/cjs/data-grid'
import { Form as DXForm, GroupItem, SimpleItem, Tab, TabbedItem } from 'devextreme-react/form'
import type { riunione } from '@/model/qsadminapi/QsAdminApiModuleModel'
import DocumentCreator from '@/components/document/DocumentCreator'
import { useRef } from 'react'
import { useQsAdminApiManager } from '@/auth/api/qsadminapiManager'
import { DocumentPermissions } from '@/enums'
import { FileManagerRef } from 'devextreme-react/cjs/file-manager'
import AttachmentsManager from '@/components/file-manager/AttachmentsManager'

export function MeetingBriefDetail(props: DataGridTypes.MasterDetailTemplateData) {
  const qsAdminApi = useQsAdminApiManager.getState().service
  const { client } = useQsAdminApiManager()
  const fileManagerRef = useRef<FileManagerRef>(null)
  const meeting: riunione = props.data.data
  const verbaleGetRef = useRef<any>(null)
  return (
    <div className={'dx-card responsive-paddings'}>
      <DXForm id={'riunione_brief_detail_form'} formData={meeting} labelLocation={'top'} readOnly={true}>
        <GroupItem colCount={5} colSpan={5}>
          <GroupItem colCount={1} colSpan={5}>
            <TabbedItem>
              <Tab title="Verbale">
                <DocumentCreator
                  title="Verbale"
                  documentUrl={meeting.mainDocumentUrl}
                  documentGetRef={verbaleGetRef}
                  action={async () => {
                    await qsAdminApi.riunione(meeting.id).CreateDocument()
                  }}
                  preliminarPermissionsAction={async () => {
                    try {
                      const response = await client.post(
                        '/api/riunione/drivepermissions',
                        {
                          objectId: meeting.id,
                          path: meeting.mainDocumentUrl,
                        },
                        {
                          headers: {
                            'Content-Type': 'application/json',
                          },
                        },
                      )
                      return response.status === 200 ? (response.data as DocumentPermissions) : DocumentPermissions.Deny
                    } catch (error) {
                      console.log('Errore in settaggio permessi sul documento riunione', error)
                      return DocumentPermissions.Deny
                    }
                  }}
                />
              </Tab>
              <Tab title="Argomento">
                <SimpleItem dataField={'argomento'} editorType={'dxTextArea'} label={{ visible: false }} />
              </Tab>
              <Tab title="Allegati">
                <AttachmentsManager
                  fileManagerRef={fileManagerRef}
                  folderUrl={meeting.attachmentsFolderUrl}
                  preliminarPermissionsAction={() => {
                    return Promise.resolve(DocumentPermissions.Read)
                  }}
                  createDirectoryAction={async (rootFolderPath: string, name: string, conflictBehavior: string) => {
                    return await client.post(
                      '/api/riunione/createfolder',
                      {
                        rootFolder: rootFolderPath,
                        newFolderName: name,
                        conflictBehavior,
                        objectId: meeting.id,
                      },
                      {
                        headers: {
                          'Content-Type': 'application/json',
                        },
                      },
                    )
                  }}
                />
              </Tab>
            </TabbedItem>
          </GroupItem>
        </GroupItem>
      </DXForm>
    </div>
  )
}
